export default [
  {
    name: 'defaultTestPatient',
    path: 'testPatient',
    component: () => import(
      /* webpackChunkName: 'defaultTestPatient' */
      '../views/test-patient/list/index.vue'),
    meta: {
      tabGroup: 'defaultTestPatient',
      keepAlive: true,
    },
  },
  {
    name: 'defaultIntentRegister',
    path: 'intentRegister',
    component: () => import(
      /* webpackChunkName: 'defaultIntentRegister' */
      '../views/intentRegister/list/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'recruitmentManagement',
    path: 'recruitmentManagement',
    component: () => import(
      /* webpackChunkName: 'recruitmentManagement' */
      '../views/patientRecruitment/recruitmentManagement/list.vue'),
  },
  {
    name: 'recruitmentManagementEdit',
    path: 'recruitmentManagementEdit',
    component: () => import(
      /* webpackChunkName: 'recruitmentManagementEdit' */
      '../views/patientRecruitment/recruitmentManagement/edit.vue'),
  },
  {
    name: 'recruitmentDataStatistics',
    path: 'recruitmentDataStatistics',
    component: () => import(
      /* webpackChunkName: 'recruitmentDataStatistics' */
      '../views/patientRecruitment/recruitmentDataStatistics/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
];
